import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";

interface CircularIndicatorParams {
    color: string;
    holidaysUsed: number;
    holidaysLeft: number;
    year: number;
}
const CircularIndicator = ({
    color,
    holidaysLeft,
    holidaysUsed,
    year,
}: CircularIndicatorParams) => {
    return (
        <div
            style={{
                position: "relative",
                width: "100px",
                height: "100px",
                marginRight: "8px",
            }}
        >
            <CircularProgress
                size={100}
                thickness={4}
                variant="determinate"
                value={100}
                sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    color: color,
                }}
            />
            <Typography
                variant="h6"
                component="div"
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    textAlign: "center",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <Typography
                    variant="h6"
                    component="span"
                    sx={{ fontSize: "34px", fontWeight: "bold" }}
                >
                    {holidaysUsed}
                    <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                        /{holidaysLeft}
                    </span>
                </Typography>
                <Typography
                    variant="body1"
                    component="span"
                    sx={{
                        fontSize: "10px",
                        color: "grey",
                        fontWeight: "bold",
                        marginTop: "-4px",
                    }}
                >
                    {year}
                </Typography>
            </Typography>
        </div>
    );
};

export default CircularIndicator;
